import Head from "next/head";
import { make as CheatSheetPage } from "../../src/info/CheatSheetPage.bs";

export default function CheatSheet() {
  return (
    <>
      <Head>
        <title>Set 18 Synergy Grid - Tft Stats & Tools</title>
      </Head>
      <CheatSheetPage set={180} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {},
    revalidate: 3600,
  };
}
